import React, { Component } from "react";
import {Card, Form, Button, Row, Col, Alert, Tab, Tabs} from "react-bootstrap";
import { IMaskInput } from "react-imask";
import api from "../../services/api";
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'
import { formataDataApi, formataDataExibicao, formataCNPJ, formataCPF, tiposGestores} from '../../common/utils';
import { withRouter } from '../../common/with-router';
import AsyncSelect from 'react-select/async';
import axios from 'axios';
import { FaArrowDown, FaArrowUp, FaCheck, FaTimes, FaStream, FaEye } from "react-icons/fa";

class GestoresEdit extends Component {
    constructor(props) {
        super(props);
        this.handleChange = this.handleChange.bind(this);
        this.onChangeCep = this.onChangeCep.bind(this);
        this.onChangeTipoPessoa = this.onChangeTipoPessoa.bind(this);

        this.enviaGestor = this.enviaGestor.bind(this);

        this.fileInput = React.createRef();

        this.state = {
            tipo_pessoa: 'fisica',
            cpf: '',
            nome: "",
            email: "",
            telefone: "",
            tipo_gestor: "",
            genero: "",
            cep: '',
            endereco: '',
            numero: '',
            complemento: '',
            bairro: '',
            cidade: '',
            uf: '',
            cliente_id: '',
            cliente_nome: '',
            nomeHelper: "",
            cpfHelper: "",
            emailHelper: "",
            telefoneHelper: "",
            tipo_gestorHelper: "",
            cepHelper: '',
            enderecoHelper: '',
            numeroHelper: '',
            complementoHelper: '',
            bairroHelper: '',
            cidadeHelper: '',
            ufHelper: '',
            clienteIdHelper: '',
            erroLoadGestor: "",
            gestor_id: "",
            titulo_pagina: "",
            loading: false,
            clientes: []
        };

        this.list_sexos = {"F": "Feminino", "M": "Masculino", "O": "Outro"};

        this.list_tipos_pessoa = {"fisica": "Física", "juridica": "Jurídica"};

        this.ufOptions = {
            "AC": "Acre",
            "AL": "Alagoas",
            "AP": "Amapá",
            "AM": "Amazonas",
            "BA": "Bahia",
            "CE": "Ceará",
            "DF": "Distrito Federal",
            "ES": "Espírito Santo",
            "GO": "Goiás",
            "MA": "Maranhão",
            "MT": "Mato Grosso",
            "MS": "Mato Grosso do Sul",
            "MG": "Minas Gerais",
            "PA": "Pará",
            "PB": "Paraíba",
            "PR": "Paraná",
            "PE": "Pernambuco",
            "PI": "Piauí",
            "RJ": "Rio de Janeiro",
            "RN": "Rio Grande do Norte",
            "RS": "Rio Grande do Sul",
            "RO": "Rondônia",
            "RR": "Roraima",
            "SC": "Santa Catarina",
            "SP": "São Paulo",
            "SE": "Sergipe",
            "TO": "Tocantins"
        };

    }

    componentDidMount(){
        const id = this.props.router.params.id;

        if(id){
            this.setState({
                gestor_id: id,
                titulo_pagina: 'Editando Gestor',
                loading: true,
                erroLoadGestor: ''
            })

            //consulta os dados do gestor na api
            api.get(`/pessoas/gestores/${id}`)
            .then(response => {
                const dados = response.data;

                //preenche os inputs
                this.setState({
                    erroLoadGestor: '',
                    nome: dados.dados_pessoa.nome,
                    cpf: (dados.dados_pessoa.cpf_cnpj) ? formataCPF(dados.dados_pessoa.cpf_cnpj) : '',
                    email: dados.dados_pessoa.email,
                    telefone: dados.dados_pessoa.telefone,
                    tipo_gestor: dados.tipo_gestor,
                    genero: dados.dados_pessoa.genero,
                    cep: dados.dados_pessoa.cep,
                    endereco: dados.dados_pessoa.endereco,
                    numero: dados.dados_pessoa.numero,
                    complemento: dados.dados_pessoa.complemento,
                    bairro: dados.dados_pessoa.bairro,
                    cidade: dados.dados_pessoa.cidade,
                    uf: dados.dados_pessoa.uf,
                    cliente_id: dados.cliente_id,
                    cliente_nome: 'SEM VALOR',
                    loading: false
                });
                this.carregarClientesGestor();  
            })
            .catch(error => {
                let erro_msg = 'Erro ao consultar gestor, tente novamente';

                if(error.response && error.response.status === 500){
                    erro_msg = 'Servidor indisponível no momento, tente novamente';
                }

                this.setState({
                    erroLoadGestor: erro_msg,
                })
            });
        }
        else {
            this.setState({
                gestor_id: '',
                titulo_pagina: 'Adicionar Gestor',
                loading: false,
                erroLoadGestor: '',
            })
        }
    }

    /*carregarClientes = async (inputValue) => {
        if (inputValue.length < 3) return [];
        try {
            const response = await api.get(`/pessoas/?categoria_pessoa=cliente&nome=${inputValue}`);
            const opcoes = response.data.results.map(cliente => ({
                value: cliente.info.id,
                label: (cliente.nome_fantasia) ? `${cliente.nome_fantasia} (${cliente.razao_social})` : `${cliente.nome}`
            }));
            //this.setState({ opcoesClientes: opcoes });
            return opcoes;
        } catch (error) {
            console.error('Erro ao carregar clientes:', error);
            return [];
        }
    };*/

    enviaGestor = (e) => {
        e.preventDefault();

        const formData = new FormData();

        this.setState({
            loading: true,
            nomeHelper: '',
            cpfHelper: '',
            emailHelper: '',
            telefoneHelper: '',
            tipo_gestorHelper: '',
        });

        //vererifica se é edição ou adição
        const url = (this.state.gestor_id) ? '/pessoas/gestores/'+this.state.gestor_id+'/' : '/pessoas/gestores/'
        const metodo = (this.state.gestor_id) ? 'put' : 'post'

        formData.append('tipo_pessoa', this.state.tipo_pessoa);
        formData.append('nome', this.state.nome);
        formData.append('cpf_cnpj', this.state.tipo_pessoa === 'fisica' ? this.state.cpf : this.state.cnpj);
        formData.append('email', this.state.email);
        formData.append('telefone', this.state.telefone);
        formData.append('cep', this.state.cep);
        formData.append('endereco', this.state.endereco);
        formData.append('numero', this.state.numero);
        formData.append('complemento', this.state.complemento);
        formData.append('bairro', this.state.bairro);
        formData.append('cidade', this.state.cidade);
        formData.append('uf', this.state.uf);
        formData.append('cliente_id', this.state.cliente_id);
        formData.append('tipo_gestor', this.state.tipo_gestor);

        //envia para api
        api({
            method: metodo,
            url: url,
            data: formData
        })
        .then(response => {
            const MySwal = withReactContent(Swal)
            const textSwal = (this.state.gestor_id) ? 'Gestor atualizado com sucesso' : 'Gestor cadastrado com sucesso';

            MySwal.fire({
                title: <p>{textSwal}</p>,
                icon: 'success',
                showCloseButton: true,
            })
            
            this.setState({
                loading: false,
            })
            
            //redireciona
            if(!this.state.gestor_id){
                this.props.router.navigate("/gestores");
            }
        })
        .catch(error => {
            let erro_msg = 'Erro ao cadastrar gestor, verifique os campos e tente novamente';            

            if(error.response && error.response.status === 500){
                erro_msg = 'Servidor indisponível no momento';
            }
            else if(error.response && error.response.status === 400){
                const campos = error.response.data;                
                
                //percorre os campos com erro
                for (let key in campos){
                    var value = campos[key];

                    if(key === 'nome'){
                        this.setState({ nomeFantasiaHelper: value })
                    }
                    if(key === 'cpf_cnpj'){
                        this.setState({ cpfHelper: value })
                    }
                    if(key === 'email'){
                        this.setState({ emailHelper: value })
                    }
                    if(key === 'telefone'){
                        this.setState({ telefoneHelper: value })
                    }                    
                    if(key === 'tipo_gestor'){
                        this.setState({ tipo_gestorHelper: value })
                    }
                    if(key === 'cep'){
                        this.setState({ cepHelper: value })
                    }
                    if(key === 'endereco'){
                        this.setState({ enderecoHelper: value })
                    }
                    if(key === 'numero'){
                        this.setState({ numeroHelper: value })
                    }
                    if(key === 'complemento'){
                        this.setState({ complementoHelper: value })
                    }
                    if(key === 'bairro'){
                        this.setState({ bairroHelper: value })
                    }
                    if(key === 'cidade'){
                        this.setState({ cidadeHelper: value })
                    }
                    if(key === 'uf'){
                        this.setState({ ufHelper: value })
                    }
                };
            }

            const MySwal = withReactContent(Swal)
            MySwal.fire({
                icon: 'error',
                showCloseButton: true,
                title: <p>{erro_msg}</p>,
            })    
            
            this.setState({
                loading: false,
            })
        });
    };

    onChangeTipoPessoa = (e) => {
        this.setState({
            tipo_pessoa: e.target.value,
            cpf: '',
            cnpj: '',
        });
    };

    handleChange = (event, fieldName) => {
        if(fieldName == 'cliente_id') {
            this.setState({ cliente_id: event.value, cliente_nome: event.label });
        } else {
            const { name, value } = event.target;
            this.setState({ [name]: value });
        }
    };

    onChangeCep(e) {
        const cep = e.target.value;
        this.setState({ cep: cep });

        if (cep.length === 9) { // Verifica se o CEP tem 9 caracteres
            axios.get(`https://viacep.com.br/ws/${cep}/json/`)
                .then(res => {
                    if (!res.data.erro) {
                        this.setState({
                            endereco: res.data.logradouro,
                            complemento: res.data.complemento,
                            bairro: res.data.bairro,
                            cidade: res.data.localidade,
                            uf: res.data.uf
                        });
                    } else {
                        // Tratar o caso de CEP não encontrado
                        console.log("CEP não encontrado.");
                    }
                })
                .catch(error => {
                    // Tratar erro na requisição
                    console.error("Erro na requisição:", error);
                });
        }
    }

    //Clientes do Gestor
    carregarClientesGestor = () => {
        if (this.state.gestor_id) {
            api.get(`/pessoas/gestores/clientes/?gestor_id=${this.state.gestor_id}`)
                .then(response => {
                    const clientesCarregados = response.data.results.map(cliente => ({
                        id: cliente.id,
                        cliente_id: cliente.cliente_id,
                        cliente_nome: cliente.dados_cliente.nome //`${cliente.dados_cliente.nome_fantasia} (${cliente.dados_cliente.razao_social})`
                    }));
                    this.setState({ clientes: clientesCarregados });
                })
                .catch(error => {
                    console.error('Erro ao carregar clientes:', error);
                    
                    let erro_msg = 'Erro ao carregar clientes do prestador, tente novamente';

                    if(error.response && error.response.status === 500){
                        erro_msg = 'Servidor indisponível no momento, tente novamente';
                    }

                    this.setState({
                        erroLoadRegistro: erro_msg,
                    })
                });
        }
    };

    salvarCliente = (index) => {
        const cliente = this.state.clientes[index];
        const url = (cliente.id) ? `/pessoas/gestores/clientes/${cliente.id}/` : '/pessoas/gestores/clientes/';
        const metodo = (cliente.id) ? 'put' : 'post';
    
        const dadosCliente = {
            gestor_id: this.state.gestor_id,
            cliente_id: cliente.cliente_id
        };

        api({
            method: metodo,
            url: url,
            data: dadosCliente,
        })
        .then(response => {
            // Se for um novo cliente, atualize o estado com a ID retornada pela API
            if (!cliente.id) {
                this.setState(prevState => {
                    const clientesAtualizados = [...prevState.clientes];
                    clientesAtualizados[index].id = response.data.id;
                    return { clientes: clientesAtualizados };
                });
            }
            
            const MySwal = withReactContent(Swal)
            const textSwal = (cliente.id) ? 'Cliente atualizado com sucesso' : 'Cliente cadastrado com sucesso';

            MySwal.fire({
                title: <p>{textSwal}</p>,
                icon: 'success',
                showCloseButton: true,
            })
            
        })
        .catch(error => {
            let erro_msg = 'Erro ao cadastrar o cliente, verifique os campos e tente novamente';   
            let content = '';         

            if(error.response && error.response.status === 500){
                erro_msg = 'Servidor indisponível no momento';
            }
            else if(error.response && error.response.status === 400){
                const campos = error.response.data;                
                
                //percorre os campos com erro
                for (let key in campos){
                    var value = campos[key];

                    if(key == 'cliente_id') {
                        content += `<br>&bull; Cliente: ${value}`;
                    }
                };
            }

            const MySwal = withReactContent(Swal)
            MySwal.fire({
                icon: 'error',
                showCloseButton: true,
                title: <p>{erro_msg}</p>,
                html: content,
            })
        });
    };

    adicionarCliente = () => {
        this.setState(prevState => ({
            clientes: [...prevState.clientes, { cliente_id: '', cliente_nome: '' }],
        }));
    };

    removerCliente = (index) => {
        const MySwal = withReactContent(Swal);
    
        MySwal.fire({
            title: 'Remover cliente?',
            text: "Tem certeza que deseja remover este cliente?",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Sim, remover!',
            cancelButtonText: 'Cancelar'
        }).then((result) => {
            if (result.isConfirmed) {

                const cliente = this.state.clientes[index];

                if (cliente.id) {

                    const url = `/pessoas/gestores/clientes/${cliente.id}/`;
                    const metodo = 'delete';
                
                    api({
                        method: metodo,
                        url: url,
                    })
                    .then(response => {
                                              
                        const MySwal = withReactContent(Swal)
                        const textSwal = 'Cliente removido com sucesso';

                        MySwal.fire({
                            title: <p>{textSwal}</p>,
                            icon: 'success',
                            showCloseButton: true,
                        })

                        this.setState(prevState => ({
                            clientes: prevState.clientes.filter((_, i) => i !== index),
                        }));
                        
                    })
                    .catch(error => {
                        let erro_msg = 'Erro ao remover o cliente, tente novamente';            

                        if(error.response && error.response.status === 500){
                            erro_msg = 'Servidor indisponível no momento';
                        }
                        else if(error.response && error.response.status === 400){
                            const campos = error.response.data;       
                            
                        }

                        const MySwal = withReactContent(Swal)
                        MySwal.fire({
                            icon: 'error',
                            showCloseButton: true,
                            title: <p>{erro_msg}</p>,
                        })
                    });

                } else {
                    this.setState(prevState => ({
                        clientes: prevState.clientes.filter((_, i) => i !== index),
                    }));
        
                    MySwal.fire(
                        'Removido!',
                        'O cliente foi removido.',
                        'success'
                    );
                }
            }
        });
    };

    handleClienteChange = (index, event, fieldName) => {
        const clientes = [...this.state.clientes];
        if (fieldName === 'cliente_id') {
            clientes[index] = { ...clientes[index], cliente_id: event.value, cliente_nome: event.label };
        } else {
            const { name, value } = event.target;
            clientes[index] = { ...clientes[index], [name]: value };
        }
        this.setState({ clientes });
    };

    carregarClientes = async (inputValue) => {
        try {
            const response = await api.get(`/pessoas/clientes/?nome=${inputValue}`);
            const opcoes = response.data.results.map(cliente => ({
                value: cliente.id,
                label: `${cliente.dados_pessoa.nome_fantasia} (${cliente.dados_pessoa.razao_social})`
            }));
            //this.setState({ opcoesClientes: opcoes });
            return opcoes;
        } catch (error) {
            console.error('Erro ao carregar clientes:', error);
            return [];
        }
    };

    render(){
        return (
            <div>
                <Row className="align-items-center">
                    <Col sm={6} lg={6}>
                        <h4 className="page-title">{this.state.titulo_pagina}</h4>
                    </Col>
                </Row>
                <Tabs defaultActiveKey="dadosGestor" id="tabs-gestor" className="aditus-tabs">
                    <Tab eventKey="dadosGestor" title="Dados do Gestor">
                        <Card className="cardDestaque">
                            <Card.Body>                    
                                <Form onSubmit={this.enviaGestor}>
                                    <h4>Dados do Gestor</h4>
                                    <Row>
                                        {this.state.tipo_pessoa === 'fisica' ? (
                                        <Col sm={6} xs={12}>
                                            <Form.Group className="mb-3">
                                                <Form.Label>CPF</Form.Label>
                                                <Form.Control as={IMaskInput} required mask="000.000.000-00" placeholder="CPF" name="cpf" id="formCpf" value={this.state.cpf} onChange={this.handleChange} />
                                                <Form.Text id="formCpfHelpBlock" className="text-danger">{this.state.cpfHelper}</Form.Text>
                                            </Form.Group>
                                        </Col>
                                        ) : (
                                            <>
                                                <Col sm={6} xs={12}>
                                                    <Form.Group className="mb-3">
                                                        <Form.Label>CNPJ</Form.Label>
                                                        <Form.Control as={IMaskInput} required mask="00.000.000/0000-00" placeholder="CNPJ" name="cnpj" id="formCnpj" value={this.state.cnpj} onChange={this.onChangeCnpj} />
                                                        <Form.Text id="formCpfHelpBlock" className="text-danger">{this.state.cnpjHelper}</Form.Text>
                                                    </Form.Group>
                                                </Col>   
                                                <Col sm={6} xs={12}>
                                                    <Form.Group className="mb-3">
                                                        <Form.Label>Razão Social</Form.Label>
                                                        <Form.Control type="text" required placeholder="Razão Social" name="razao_social" id="forRazaoSocial" value={this.state.razao_social} onChange={this.onChangeRazaoSocial} />                            
                                                        <Form.Text id="formRazaoSocialHelpBlock" className="text-danger">{this.razaoSocialHelper}</Form.Text>
                                                    </Form.Group>
                                                </Col>
                                                <Col sm={6} xs={12}>
                                                    <Form.Group className="mb-3">
                                                        <Form.Label>Nome Fantasia</Form.Label>
                                                        <Form.Control type="text" required placeholder="Nome Fantasia" name="nome_fantasia" id="formNomeFantasia" value={this.state.nome_fantasia} onChange={this.onChangeNomeFantasia} />                            
                                                        <Form.Text id="formNomeFantasiaHelpBlock" className="text-danger">{this.nomeFantasiaHelper}</Form.Text>
                                                    </Form.Group>
                                                </Col>
                                            </>
                                        )}
                                        <Col sm={6} xs={12}>
                                            <Form.Group className="mb-3">
                                                <Form.Label>Nome</Form.Label>
                                                <Form.Control type="text" required placeholder="Nome" name="nome" value={this.state.nome} onChange={this.handleChange} />                            
                                                <Form.Text id="formNomeHelpBlock" className="text-danger">{this.nomeHelper}</Form.Text>
                                            </Form.Group>
                                        </Col>
                                        <Col sm={6} xs={12}>
                                            <Form.Group className="mb-3">
                                                <Form.Label>Email</Form.Label>
                                                <Form.Control type="email" required placeholder="E-mail" name="email" id="formEmail" value={this.state.email} onChange={this.handleChange} />                            
                                                <Form.Text id="formEmailHelpBlock" className="text-danger">{this.state.emailHelper}</Form.Text>
                                            </Form.Group>
                                        </Col>
                                        <Col sm={6} xs={12}>
                                            <Form.Group className="mb-3">
                                                <Form.Label>Telefone</Form.Label>
                                                <Form.Control as={IMaskInput} required mask="(00) 00000-0000" placeholder="Telefone do cliente" name="telefone" id="formTelefone" value={this.state.telefone} onChange={this.handleChange} />
                                                <Form.Text id="formTelefoneHelpBlock" className="text-danger">{this.state.telefoneHelper}</Form.Text>
                                            </Form.Group>
                                        </Col>
                                        <Col sm={6} xs={12}>
                                            <Form.Group className="mb-3">
                                                <Form.Label>Tipo do gestor</Form.Label>
                                                <Form.Control as="select" name="tipo_gestor" value={this.state.tipo_gestor} required onChange={this.handleChange}>
                                                    <option value="">Selecione o tipo...</option>
                                                    {Object.entries(tiposGestores).map(([tipo, nome]) => (
                                                        <option key={tipo} value={tipo}>{nome}</option>
                                                    ))}
                                                </Form.Control>
                                                <Form.Text id="formTipoGestorHelpBlock" className="text-danger">{this.state.tipo_gestorHelper}</Form.Text>
                                            </Form.Group>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <h4 className="mt-3">Endereço</h4>
                                        <Col sm={12} xs={12}>
                                            <Row>
                                                <Col sm={6} xs={12}>
                                                    <Form.Group className="mb-3">
                                                        <Form.Label>CEP</Form.Label>
                                                        <Form.Control as={IMaskInput} required mask="00000-000" name="cep" type="text" placeholder="CEP" value={this.state.cep} onChange={this.onChangeCep} />
                                                        <Form.Text id="formCEPHelpBlock" className="text-danger">{this.state.cepHelper}</Form.Text>
                                                    </Form.Group>
                                                </Col>
                                                <Col sm={6} xs={12}>
                                                    <Form.Group className="mb-3">
                                                        <Form.Label>Endereço</Form.Label>
                                                        <Form.Control type="text" required placeholder="Endereço" name="endereco" value={this.state.endereco} onChange={this.handleChange} />
                                                        <Form.Text id="formEnderecoHelpBlock" className="text-danger">{this.state.enderecoHelper}</Form.Text>
                                                    </Form.Group>
                                                </Col>
                                                <Col sm={6} xs={12}>
                                                    <Form.Group className="mb-3">
                                                        <Form.Label>Número</Form.Label>
                                                        <Form.Control type="text" required placeholder="Número" name="numero" value={this.state.numero} onChange={this.handleChange} />
                                                        <Form.Text id="formNumeroHelpBlock" className="text-danger">{this.state.numeroHelper}</Form.Text>
                                                    </Form.Group>
                                                </Col>
                                                <Col sm={6} xs={12}>
                                                    <Form.Group className="mb-3">
                                                        <Form.Label>Complemento</Form.Label>
                                                        <Form.Control type="text" placeholder="Complemento" name="complemento" value={this.state.complemento} onChange={this.handleChange} />
                                                    </Form.Group>
                                                </Col>
                                                <Col sm={6} xs={12}>
                                                    <Form.Group className="mb-3">
                                                        <Form.Label>Bairro</Form.Label>
                                                        <Form.Control type="text" placeholder="Bairro" name="bairro" value={this.state.bairro} onChange={this.handleChange} />
                                                        <Form.Text id="formBairroHelpBlock" className="text-danger">{this.state.bairroHelper}</Form.Text>
                                                    </Form.Group>
                                                </Col>
                                                <Col sm={6} xs={12}>
                                                    <Form.Group className="mb-3">
                                                        <Form.Label>Cidade</Form.Label>
                                                        <Form.Control type="text" placeholder="Cidade" name="cidade" value={this.state.cidade} onChange={this.handleChange} />
                                                        <Form.Text id="formCidadeHelpBlock" className="text-danger">{this.state.cidadeHelper}</Form.Text>
                                                    </Form.Group>
                                                </Col>
                                                <Col sm={6} xs={12}>
                                                    <Form.Group className="mb-3">
                                                        <Form.Label>UF</Form.Label>
                                                        <Form.Control as="select" value={this.state.uf} name="uf" required onChange={this.handleChange}>
                                                            <option value="">Selecione o Estado</option>
                                                            {Object.entries(this.ufOptions).map(([sigla, nome]) => (
                                                                <option key={sigla} value={sigla}>{nome}</option>
                                                            ))}
                                                        </Form.Control>
                                                        <Form.Text id="formUFHelpBlock" className="text-danger">{this.state.ufHelper}</Form.Text>
                                                    </Form.Group>
                                                </Col>
                                            </Row>                                    
                                        </Col>
                                    </Row>  
                                    {this.state.erroLoadGestor ? 
                                    <Alert variant="warning">
                                        {this.state.erroLoadGestor}
                                    </Alert> : ''
                                    }                                      
                                    <Button variant="success" type="submit" className="btn-submit mt-3" disabled={this.state.loading}>
                                        {this.state.loading ? (
                                            <span className="spinner-border spinner-border-sm"></span>
                                        ) : (
                                            <>
                                                <FaCheck className="me-1" /> Salvar
                                            </>
                                        )}
                                    </Button>
                                </Form> 
                            </Card.Body>                
                        </Card>
                    </Tab>
                    {this.state.gestor_id && (
                        <Tab eventKey="clientesGestor" title="Clientes">
                            <Card className="cardDestaque">
                                <Card.Body>                    
                                    <Form onSubmit={this.enviaClientesGestor}>
                                        <h4>Clientes do Gestor</h4>
                                        {this.state.clientes.map((cliente, index) => (
                                            <div key={index} className="row-list">
                                                <Row>
                                                    <Col sm={6}>
                                                        <Form.Group className="mb-3">
                                                            <Form.Label>Cliente</Form.Label>
                                                            <AsyncSelect
                                                                cacheOptions
                                                                loadOptions={this.carregarClientes}
                                                                defaultOptions
                                                                name="cliente_id"
                                                                placeholder="Buscar cliente..."
                                                                noOptionsMessage={() => "Nenhum cliente encontrado"}
                                                                onChange={e => this.handleClienteChange(index, e, 'cliente_id')}
                                                                value={cliente.cliente_id ? { value: cliente.cliente_id, label: cliente.cliente_nome } : null}
                                                            />
                                                        </Form.Group>
                                                    </Col>
                                                </Row>
                                                <Button variant="success" className="btn-sm" onClick={() => this.salvarCliente(index)}><FaCheck className="me-1" /> Salvar Cliente</Button>&nbsp;&nbsp;
                                                <Button variant="danger" className="btn-sm ml-3" onClick={() => this.removerCliente(index)}><FaTimes className="me-1" /> Remover Cliente</Button>
                                                <hr />
                                            </div>
                                        ))}
                                        <Button variant="secondary" onClick={this.adicionarCliente}><FaStream /> Adicionar Cliente</Button>
                                    </Form> 
                                </Card.Body>                
                            </Card>
                        </Tab>
                    )}  
                </Tabs>
            </div>
        )
    }
}

export default withRouter(GestoresEdit);